import React, { useRef, useState } from 'react';
import { Select, MenuItem, FormControl, InputLabel, Tooltip, Paper, InputBase, Button, Menu, Popover } from '@material-ui/core';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const CustomDropdown = ({ options, value, onChange, label }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const inputRef = useRef(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => inputRef.current?.focus(), 100); // Delay for stability
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSearchTerm(""); // Reset search on close
  };

  const handleSelect = (option) => {
    onChange(option);
    handleClose();
  };

  const filteredOptions = options.filter((option) =>
    option.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <FormControl fullWidth variant="outlined" style={{ width: "300px" }}>
      <InputLabel>{label}</InputLabel>

      {/* Button to Open Dropdown */}
      {/* <div> */}


      <Button
        variant="outlined"
        onClick={handleOpen}
        fullWidth
        style={{
          display: "flex",
          color: value ? "#000" : "#666",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "left",
          textTransform: "none",
          padding: "6px 12px",
          whiteSpace: "nowrap",       // Prevents text wrap
          overflow: "hidden",         // Hides overflow
          textOverflow: "ellipsis"    // Adds "..."
        }}
      >
        <Tooltip title={value||"Select an option"} placement="right">

                <span
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                    lineHeight: '1.4em',
                    maxHeight: '2.8em',  // 1.4em * 2 lines
                    whiteSpace: 'normal',
                    width: '250px',      // Adjust as per layout
                  }}
                >
                  {value ||"Select an option"}
                </span>
              </Tooltip>
        {/* <Tooltip title={value || "Select an option"} arrow>
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flexGrow: 1
            }}
          >
            {value || "Select an option"}
          </span>
        </Tooltip> */}
        <KeyboardArrowDownIcon style={{ marginLeft: "8px", flexShrink: 0 }} />
      </Button>
      {/* </div> */}
      {/* Custom Popover (Replaces Menu) */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        disableAutoFocus // Prevents popover from stealing focus
        disableEnforceFocus // Allows input field to stay focused
        PaperProps={{ style: { maxHeight: 250, width: anchorEl?.offsetWidth || 300, overflowY: "auto" } }}
      >
        {/* 🔥 Sticky Search Field */}
        <Paper style={{
          width: "100%",
          padding: "4px 8px",
          position: "sticky",
          top: 0,
          background: "white",
          zIndex: 10
        }}>
          <InputBase
            inputRef={inputRef} // Ensure input remains focused
            fullWidth
            placeholder="Search SKU..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </Paper>

        {/* Filtered Options */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option, index) => (
            <MenuItem key={index} onClick={() => handleSelect(option)}>
              <Tooltip title={option} placement="right">

                <span
                  style={{
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-word',
                    lineHeight: '1.4em',
                    maxHeight: '2.8em',  // 1.4em * 2 lines
                    whiteSpace: 'normal',
                    width: '250px',      // Adjust as per layout
                  }}
                >
                  {option}
                </span>
              </Tooltip>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>No options found</MenuItem>
        )}
      </Popover>
    </FormControl>
  );
};


export default CustomDropdown;

